export default "__VITE_ASSET__CBERWKTQ__"